// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @01.09.2017 11:59:17
import { CreateMobilisationArgs_abstract } from './../../abstract/SagaBase/Defines/CreateMobilisationArgs_abstract';
export class CreateMobilisationArgs extends CreateMobilisationArgs_abstract {}
